import { interlude } from "@/interlude";

function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}

export const useExportBillingUsage = () => {
  const mutation = interlude.billing.useExportBillingUsage(
    {
      // Response is an xlsx Blob; opt out of the instance-level JSON
      // transformResponse in `interludeAxios` so the Blob reaches Zodios
      // untouched and passes the `z.instanceof(Blob)` check.
      responseType: "blob",
      transformResponse: [(data: unknown) => data],
    },
    {
      onSuccess: (blob, { month }) => {
        triggerDownload(blob, `billing_daily_breakdown_${month}.xlsx`);
      },
    },
  );

  return mutation;
};
